// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime-corejs2/node_modules/core-js/library/modules/_defined.js
// module id = 26
// module chunks = 0